export const keying_py_consummer = (
  dataKeying: {
    documento: any,
    primer_nombre: string,
    segundo_nombre: string
    primer_apellido: string,
    segundo_apellido: string,
    nombre_completo: string,
    apellido_casada: string,
    fecha_nacimiento: string,
    identifyType: string,
    pais_documento_id: string,
  }
) => {


    let IDENTIFIER_TYPE
    try {
      IDENTIFIER_TYPE = 'IDENTIFIER_TYPE' + (parseInt(dataKeying?.identifyType) > 1 ? `_${dataKeying.identifyType}`: '')
    } catch (error) {
      IDENTIFIER_TYPE = 'IDENTIFIER_TYPE'
    }


    let IDENTIFIER_NUMBER;
    try {
      IDENTIFIER_NUMBER = 'IDENTIFIER_NUMBER' + (parseInt(dataKeying?.identifyType) > 1 ? `_${dataKeying.identifyType}`: '')
    } catch (error) {
      IDENTIFIER_NUMBER = 'IDENTIFIER_NUMBER'
    }


  return [
    {
      request: {
        session: {
          quoteback: "",
          customerId: "",
          profileId: "dfkl_py_profile_consumer_countrybirth_exactlyfuzzy1",
          entityType: "CONSUMER",
        },
        entity: {
          consumer: {
            names: [
              {
                data: {
                  NAME_FIRST_NAME: dataKeying.primer_nombre,
                  NAME_MIDDLE_NAME: dataKeying.segundo_nombre,
                  NAME_LAST_NAME: dataKeying.primer_apellido ,
                  NAME_SECOND_LAST_NAME: dataKeying.segundo_apellido,
                  NAME_MARRIED_LAST_NAME: dataKeying.apellido_casada,
                  NAME_FULL: dataKeying.nombre_completo,
                  NAME_PREFIX: "",
                  NAME_SUFFIX: "",
                },
              },
            ],
            identifiers: {
              /*SOLO EN LOS DOCUMENTOS QUE CORRESPONDAN*/
              [`${IDENTIFIER_TYPE}`]: `${dataKeying.identifyType}${dataKeying.pais_documento_id}`,
              [`${IDENTIFIER_NUMBER}`]: dataKeying.documento,
              IDENTIFIER_STATEDL: "",
              IDENTIFIER_ORIGIN_COUNTRY_NUMERIC_CODE: "600",
              IDENTIFIER_ORIGIN_COUNTRY_NAME: "PARAGUAY",
              IDENTIFIER_SSN: "",
              IDENTIFIER_ORIGIN_COUNTRY_CODE: "PY",
            },
            dob: {
              DOB_DAY_OF_BIRTH: "",
              DOB_DATE: dataKeying.fecha_nacimiento,
              DOB_YEAR_OF_BIRTH: "",
              DOB_MONTH_OF_BIRTH: "",
            },
            gender: 0,
            addresses: [
              {
                data: {
                  ADDRESS_STREET_NAME: "",
                  ADDRESS_UNIT_TYPE: "",
                  ADDRESS_FIPS_CODE: "",
                  ADDRESS_UNIT_NUMBER: "",
                  ADDRESS_ZIP5: "",
                  ADDRESS_ZIP4: "",
                  ADDRESS_CITY: "",
                  ADDRESS_STREET_NUMBER: "",
                  ADDRESS_STATE: "",
                },
              },
            ],
            phones: {
              PHONE_HOME: "",
              PHONE_OFFICE: "",
              PHONE_PCS: "",
              PHONE_FAX: "",
              PHONE_CHILDREN: "",
              PHONE_PAGER: "",
              PHONE_CELL: "",
              PHONE_OTHERS: "",
            },
            legacyIds: {},
            emails: {
              EMAIL_HOME: "",
            },
            lineageKey: "",
            discoveryData: {},
          },
          commercial: null,
        },
      },
      response: null,
    },
  ];
};
